const NOTIFICATION_TYPE_ERROR = 1001;
const NOTIFICATION_TYPE_INFO = 1002;
const NOTIFICATION_TYPE_SUCCESS = 1003;

const displayNotification = (message, type = NOTIFICATION_TYPE_ERROR, cooldown = 5) => {
    const notificationsHolder = $('#toasts-holder');
    let notificationClass = '';
    let notificationIcon = '';
    switch (type) {
        case NOTIFICATION_TYPE_ERROR:
            notificationClass = 'toast-pink';
            notificationIcon = '/dist/plan_games/images/icons/toeast-pink.svg';
            break;
        case NOTIFICATION_TYPE_INFO:
            notificationClass = 'toast-blue';
            notificationIcon = '/dist/plan_games/images/icons/toast-blue.svg';
            break;
        case NOTIFICATION_TYPE_SUCCESS:
            notificationClass = 'toast-green';
            notificationIcon = '/dist/plan_games/images/icons/toast-green.svg';
            break;
    }
    let notificationHtml = `
        <div class="toast-c ` + notificationClass + ` position-relative br-5">
            <div class="row align-items-center align-items-center">
               <div class="col-auto">
                   <picture>
                       <img src="` + notificationIcon + `" alt="">
                   </picture>
               </div>
               <div class="col">
                   <div class="row no-gutters align-items-center">
                       <div class="col">
                           <p>` + message + `</p>
                       </div>
                   </div>
               </div>
               <div class="col-auto">
                  <button class="close-t">
                     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" focusable="false" color="var(--token-1f562517-2d6c-4b17-b95b-0557cdce1790, rgb(123, 132, 142)) /* {&quot;name&quot;:&quot;04&quot;} */" style="user-select: none; width: 24px; height: 24px; display: inline-block; fill: var(--token-1f562517-2d6c-4b17-b95b-0557cdce1790, rgb(123, 132, 142)) ; flex-shrink: 0;"><g color="var(--token-1f562517-2d6c-4b17-b95b-0557cdce1790, rgb(123, 132, 142)) /* {&quot;name&quot;:&quot;04&quot;} */" weight="fill"><path d="M139.31348,128l66.34326-66.34326a7.99984,7.99984,0,0,0-11.31348-11.31348L128,116.68652,61.65674,50.34326A7.99984,7.99984,0,0,0,50.34326,61.65674L116.68652,128,50.34326,194.34326a7.99984,7.99984,0,1,0,11.31348,11.31348L128,139.31348l66.34326,66.34326a7.99984,7.99984,0,0,0,11.31348-11.31348Z"></path></g></svg>
                  </button>
               </div>
            </div>
            <span class="c-progress-bar"></span>
            <span class="progress-bar-h">
               <span class="progress-bar-c">

               </span>
            </span>
        </div>`;
    let notification = $(notificationHtml);
    notificationsHolder.prepend(notification);
    let timeout = null;

    if (cooldown > 0) { // don't hide notification after x seconds if cooldown is 0 or negative
        notification.find('.progress-bar-c').animate(
            { width: 0 },
            { duration: cooldown * 1000 }
        );
        timeout = setTimeout(function () {
            notification.animate({
                opacity: 0,
                right: "-=420px"
            }, 400 );
            setTimeout(function() {
                notification.remove();
            }, 700);
        }, cooldown * 1000);
    }


    notification.find('.close-t').click(function() {
        clearTimeout(timeout);
        notification.animate({
            opacity: 0,
            right: "-=420px"
        }, 400 );
        setTimeout(function() {notification.remove();}, 700);
    });
};

var handleSubmitErrors = (data, handleFields = true) => {
    if (data.messages) {
        data.messages.forEach((message) => {
            displayNotification(message.message, message.type, message.delay);
        });
    }
    if (handleFields && data.fields) {
        const inputHandler = (e) => {
            $(e.target).removeClass('error-input').off('focusin input', inputHandler);
        }
        for (let fieldName of data.fields) {
            $('input[name="'+fieldName+'"]').addClass('error-input').on('focusin input', inputHandler);
        }
    }
};

/**
 * A function that displays an error to the user
 *
 * The function, depending on the option can light up in red the input field or a separate element provider in the options, show a notification box
 * in the upper right corner and show an error message attached to an errorTextObject
 *
 * Possible options parameters:
 *
 *      -- showNotification - whether do display the notification in the upper right corner, defaults to true
 *
 *      -- showInputHighlight - whether to light up the input field in red, defaults to true if input provided, otherwise - false
 *
 *      -- inputHighlightElement - an option to supply a different element to highlight in red than the input, useful for custom radio/checkbox inputs
 *          defaults to the input parameter
 *
 *      -- showErrorTextMessage - whether to display the error in the errorTextObject, defaults to true if errorTextObject provided
 *
 *      -- errorObjectMessage - possibility to add a separate message from the one provided to be displayed to the errorTextObject, defaults to the message parameter
 *
 *      -- handleErrorHighlightRemoval - whether the highlight and the error text object should be automatically removed and hidden respectively
 *          This is done by attaching a input, change, focus listener to the input element which deletes itself after the first trigger.
 *          Defaults to false
 *
 * @param message - the message to be displayed to the user
 * @param input - an input object that is the cause for the error, defaults to null
 * @param errorTextObject - a separate element to display the error in, defaults to null
 * @param options - extra options for the function, check above
 */
const displayError = (message, input = null, errorTextObject = null, options = {}) => {}

const playerNotifications = {
    notifications: (type, settings = {}) => {
        if (!playerNotifications.ACTIVE_REQUESTS.unreadNotifications[type]) {
            playerNotifications.ACTIVE_REQUESTS.unreadNotifications[type] =  new Promise((resolve, reject) => {
                fetch('/player/unread-notifications?' + new URLSearchParams({type: type}).toString(), settings)
                    .then(response => response.json())
                    .then((data) => {
                        resolve(data);
                        playerNotifications.ACTIVE_REQUESTS.unreadNotifications[type] = null;
                    })
                    .catch(reject)
            });
        }

        return playerNotifications.ACTIVE_REQUESTS.unreadNotifications[type];
    },
    notificationsWithPage: (type, page = 0, perPage = 50, settings = {}) =>
        new Promise((resolve,reject) => {
            fetch('/player/unread-notifications?' + new URLSearchParams({type: type, page: page, perPage: perPage}).toString(), settings)
                .then(response => response.json())
                .then(resolve)
                .catch(reject)
        }),
    allNotifications: (type, settings = {}) => {
        if (!playerNotifications.ACTIVE_REQUESTS.allNotifications[type]) {
            playerNotifications.ACTIVE_REQUESTS.allNotifications[type] =  new Promise((resolve, reject) => {
                fetch('/player/all-notifications?' + new URLSearchParams({type: type}).toString(), settings)
                    .then(response => response.json())
                    .then((data) => {
                        resolve(data);
                        playerNotifications.ACTIVE_REQUESTS.allNotifications[type] = null;
                    })
                    .catch(reject)
            });
        }

        return playerNotifications.ACTIVE_REQUESTS.allNotifications[type];
    },
    allNotificationsWithPage: (type, page = 0, perPage = 50, settings = {}) =>
        new Promise((resolve,reject) => {
            fetch('/player/all-notifications?' + new URLSearchParams({type: type, page: page, perPage: perPage}).toString(), settings)
                .then(response => response.json())
                .then(resolve)
                .catch(reject)
        }),
    lastNotification: (type, settings = {}) => {
        if (!playerNotifications.ACTIVE_REQUESTS.lastNotification[type]) {
            playerNotifications.ACTIVE_REQUESTS.lastNotification[type] = new Promise((resolve, reject) => {
                fetch('/player/last-notifications?' + new URLSearchParams({type: type}).toString(), settings)
                    .then(response => response.json())
                    .then((data) => {
                        resolve(data);
                        playerNotifications.ACTIVE_REQUESTS.lastNotification[type] = null;
                    })
                    .catch(reject)
            });
        }

        return playerNotifications.ACTIVE_REQUESTS.lastNotification[type];
    },
    markRead: (id, settings = {}) =>
        new Promise((resolve, reject) => {
            fetch('/player/mark-notification-read?' + new URLSearchParams({id: id}).toString(), {
                method: 'POST',
                ...settings
            })
                .then(response => response.json())
                .then(resolve)
                .catch(reject)
        }),
    clearAll: (type, settings = {}) =>
        new Promise((resolve, reject) => {
            fetch('/player/clear-notifications?' + new URLSearchParams({type: type}).toString(), {
                method: 'POST',
                ...settings
            })
                .then(response => response.json())
                .then(resolve)
                .catch(reject)
        }),
    TYPE: {
        HEADER: 'header',
        GAMEPLAY: 'gameplay',
        MODAL: 'modal',
        TOAST: 'toast',
        POPUP: 'popup',
    },
    ACTIVE_REQUESTS: {
        unreadNotifications: {
            header: null,
            gameplay: null,
            modal: null,
            toast: null,
            popup: null,
        },
        allNotifications: {
            header: null,
            gameplay: null,
            modal: null,
            toast: null,
            popup: null,
        },
        lastNotification: {
            header: null,
            gameplay: null,
            modal: null,
            toast: null,
            popup: null,
        }
    }
};

const getMonthName = (month) => {
    return ([
        translationsArray['january[month]'],
        translationsArray['february[month]'],
        translationsArray['march[month]'],
        translationsArray['april[month]'],
        translationsArray['may[month]'],
        translationsArray['june[month]'],
        translationsArray['july[month]'],
        translationsArray['august[month]'],
        translationsArray['september[month]'],
        translationsArray['october[month]'],
        translationsArray['november[month]'],
        translationsArray['december[month]'],
    ])[month - 1];
}

const buildNotificationTimeString = (notificationCreatedAt) => {
    let dateTime = new Date(notificationCreatedAt.replace(/\s/, 'T') + 'Z');
    let now = new Date();
    const [year, month, date] = [dateTime.getFullYear(), dateTime.getMonth() + 1, dateTime.getDate()];

    let result = '';
    if (year == now.getFullYear() && month == now.getMonth() + 1 && date == now.getDate()) {
        result = translationsArray['today'];
    } else {
        result = date + ' ' + getMonthName(month);
        if (year != now.getFullYear()) {
            result += ' ' + year;
        }
    }

    return result;
}

const renderPlayerNotification = (notification, removeNotificationOnRead = false) => {
    let html = ''

    let time = buildNotificationTimeString(notification.created_at);
    const dataString = `data-id="${notification.id}" data-type="${notification.type}" data-name="${notification.internal_name}"`
    if (!notification.image) {
        html = `
            <div class="notification-c notification-m position-relative bg-600 ` + (notification.is_read ? '' : 'unread-message ') +`br-10" ` + dataString + `>
                ` + (notification.url ? `<a data-id="${notification.id}" href="${notification.url}" class="stretched-link"></a>` : '') + `
                <h4 class="notification-c__time">${time}</h4>
                <div class="notification-c__text">${notification.text}</div>
            </div>`;
    } else {
        html = `
            <div class="notification-c icon-notification position-relative bg-600 ` + (notification.is_read ? '' : 'unread-message ') + `br-10" ` + dataString + `>
                ` + (notification.url ? `<a data-id="${notification.id}" href="${notification.url}" class="stretched-link"></a>` : '') + `
                <div class="notification-c__content">
                  <h4 class="notification-c__time">${time}</h4>
                  <div class="notification-c__text">${notification.text}</div>
                </div>
            </div>`;
    }

    const element = $($.parseHTML(html));
    element.on('click', (e) => {
        const customerIoData = { name: notification.internal_name };
        if (notification.url) {
            customerIoData.url = notification.url;
        }
        trackCioPlayer(CUSTOMER_IO_EVENTS.NOTIFICATION_CLICKED, customerIoData);

        if (element.hasClass('unread-message')) {
            playerNotifications.markRead(notification.id).then(() => {
                $('body').trigger('notificationRead', [notification.id]);
            });

            element.removeClass('unread-message');
        }

        if (removeNotificationOnRead)
            element.remove();

        // if (!notification.url) {
        //     e.preventDefault();
        //     return false;
        // }
    });

    return element;
}

const renderToastNotification = (data) => {
    executeOnReady(() => {
        const notificationsHolder = $('#toast-notifications-holder');

        const imageHtml = data.url ?
            `<div class="big-win__imgWrap position-relative"><a class="big-win__game-url" href="${data.url}"></a><img src="${data.image}" alt="Slot image" class="big-win__img"></div>` :
            `<div class="big-win__imgWrap"><img src="${data.image}" alt="Slot image" class="big-win__img"></div>`;
        const html = `
            <div class="big-win">
                ${imageHtml}
                <div class="big-win__content">${data.text}</div>

                <button class="big-win__close-button" type="button" data-dismiss="modal">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 4L4 12" stroke="#ACACBF" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M4 4L12 12" stroke="#ACACBF" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </button>
            </div>`;

        const notification = $(html);
        notificationsHolder.prepend(notification);
        let timeout = null;

        if (data.duration > 0) { // don't hide notification after x seconds if cooldown is 0 or negative
            timeout = setTimeout(function () {
                notification.animate({
                    opacity: 0,
                    right: "-=420px"
                }, 400 );
                setTimeout(function() {
                    notification.remove();
                }, 500);
            }, data.duration * 1000);
        }


        notification.find('.big-win__close-button').click(function() {
            clearTimeout(timeout);
            notification.animate({
                opacity: 0,
                right: "-=420px"
            }, 400 );
            setTimeout(function() {notification.remove();}, 500);
        });
    });
}

(() => {
    const modalNotificationsQueue = [];
    const modal = document.querySelector('#notification-modal');
    let pendingPopup = false;
    executeOnReady(() => {
        $(modal).on('hidden.bs.modal', () => {
            pendingPopup = false;
            showNextNotification();
        });

        $(modal).on('hide.bs.modal', () => {
            const id = modal.getAttribute('data-notification-id');
            playerNotifications.markRead(id);
        });
    });

    const showNextNotification = () => {
        if (pendingPopup || !modalNotificationsQueue.length) return;
        pendingPopup = true;
        const data = modalNotificationsQueue.shift();
        executeOnReady(() => {
            const image = modal.querySelector('#notification-modal__image');
            const text = modal.querySelector('#notification-modal__text');
            const openButton = modal.querySelector('#notification-modal__open');
            const openButtonFake = modal.querySelector('#notification-modal__open-fake');
            const closeButton = modal.querySelector('#notification-modal__close');

            [openButton, closeButton].forEach(button => {
                $(button).off('click');
                $(button).on('click', () => { $(modal).modal('hide'); });
            });
            $(openButtonFake).off('click');
            $(openButtonFake).on('click', () => {
                openButton.click();
            });

            image.setAttribute('src', data.image);
            openButton.setAttribute('href', data.url);
            openButtonFake.textContent = data.button_text;
            text.innerHTML = data.text;
            modal.setAttribute('data-notification-id', data.id);
            $(modal).modal('show');
        });
    }

    window.renderModalNotification = (data) => {
        modalNotificationsQueue.push(data);
        showNextNotification();
    }
})();

(() => {
    const popupNotificationQueue = [];
    let currentlyOpen = false;
    let currentTimeout = null;

    const buildPopupHtml = (data) => {
        let buttonHtml = '';
        if (data.button_text || data.url) {
            buttonHtml = `<a href="${data.url}" class="low-balance__link">${data.button_text}</a>`;
        }
        return `
            <div class="low-balance low-balance--second" id="popup-notification">
                <div class="low-balance__content">${data.text}</div>
                ${buttonHtml}
                <button id="popup-notification-close-button" class="low-balance__close-button" type="button" data-dismiss="modal">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 4L4 12" stroke="#ACACBF" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M4 4L12 12" stroke="#ACACBF" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </button>
            </div>`;
    }

    const closeNotification = (notification, notificationData) => {
        notification.remove();
        currentlyOpen = false;
        playerNotifications.markRead(notificationData.id);
        clearTimeout(currentTimeout);

        showNextNotification();
    }

    const showNextNotification = () => {
        if (currentlyOpen || !popupNotificationQueue.length) return;
        currentlyOpen = true;
        const notificationData = popupNotificationQueue.shift();
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = buildPopupHtml(notificationData);
        document.querySelector('body').appendChild(tempDiv.children[0]);

        const popupNotification = document.querySelector('#popup-notification');
        const buttons = popupNotification.querySelectorAll('a, button');
        for (const button of buttons) {
            button.addEventListener('click', () => {
                closeNotification(popupNotification, notificationData);
            });
        }

        if ((notificationData.duration ?? false) && notificationData.duration > 0) {
            currentTimeout = setTimeout(() => {
                closeNotification(popupNotification, notificationData);
            }, notificationData.duration * 1000);
        }
    }

    window.renderPopupNotification = (data) => {
        popupNotificationQueue.push(data);
        showNextNotification();
    }
})();
